<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/no-unused-vars -->
<template>
  <link href="https://fonts.googleapis.com/css?family=Pacifico" rel="stylesheet">
  <template v-if="useRuntimeConfig().public.SHOP_NAME=='LSDOPE'">
    <BgLava />
  </template>
  <template v-if="useRuntimeConfig().public.SHOP_NAME=='NyxKnacks'">
    <!-- <BgSvg2 class="absolute h-full w-full scale-150" /> -->
    <!-- <div class="h-full w-full absolute bg-neutral-content" /> -->
    <div class="backdiv" />
    <BgSvg class="fixed h-full ml-n4 mt-n4" />
    <BgSvg class="fixed bottom-0 right-0 mr-n4 h-full rotate-180" />
    <!-- <img 
      src="https://static.basicinvite.com/media/bi/36259/dainty-flower-garden-wallpaper-2x.jpg?q=1701885786" 
      class="fixed w-full"> -->

    <!-- <img 
    class="backdiv h-screen backimg" /> -->
    <!-- <img
      src="https://icon2.cleanpng.com/20240403/uby/transparent-flower-frame-colorful-flower-frame-with-intricate-design660cf562b67c00.02579440.webp" 
      class="absolute rotate-180"
    >
    <img
      src="https://icon2.cleanpng.com/20240403/uby/transparent-flower-frame-colorful-flower-frame-with-intricate-design660cf562b67c00.02579440.webp" 
      class="absolute bottom-0 right-0"
    > -->
  </template>
  <NuxtLoadingIndicator />
  
  <v-app>
    <ClientOnly>
      <v-navigation-drawer
        v-model="wishdrawer"
        temporary
      >
        <Wish />
      </v-navigation-drawer>
    </ClientOnly>
    <ClientOnly>
      <v-navigation-drawer
        v-model="themedrawer"
        temporary
      >
        <ToggleTheme />
      </v-navigation-drawer>
    </ClientOnly>
    
    
    <!-- v-if="!((useRoute().path=='/' || useRoute().path.startsWith('/shop/products/')) && $device.isDesktopOrTablet)"  -->
    <div
      v-if="!((useRoute().path=='/' || useRoute().path.startsWith('/shop/products/')) && $device.isDesktopOrTablet)"
      class="py-2 b-[100px] px-3 gap-4 z-10 flex justify-space-around align-center bg-base-100 w-full fixed rounded-none w-fill xs:top-3 xs:right-5 xs:rounded-full xs:w-auto elevation-4"
    >
      <v-icon
        icon="mdi-brightness-4"
        size="large"
        style="color: oklch(var(--n));"
        @click="themedrawer = !themedrawer"
      />
      <NuxtLink to="/">
        <v-icon
          icon="mdi-home"
          size="large"
          style="color: oklch(var(--n));"
        />
      </NuxtLink>
      <NuxtLink to="/account">
        <v-icon
          icon="mdi-account"
          size="large"
          style="color: oklch(var(--n));"
        />
      </NuxtLink>
      <NuxtLink to="/checkout">
        <v-icon
          icon="mdi-cart"
          size="large"
          style="color: oklch(var(--n));"
        />
        <div v-if="useUserDataStore().userData.cart.length>0" class="fixed top-3 right-[70px]">
          <span class="relative flex h-5 w-5 justify-center align-center">
            <!-- <v-icon icon="mdi-flower-poppy" color="primary" class="spin" /> -->
                 <svg class="spin" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="m0 0h24v24h-24z" fill-rule="nonzero"/><path d="m7.00004 3.33972c1.02576-.59222 2.20878-.5506 3.24046-.13102.6605.26862 1.2829.69834 1.8187 1.25465.55-.53051 1.1648-.94601 1.8054-1.21117.9971-.41264 2.1413-.48636 3.1354.0876.9942.57396 1.5025 1.6018 1.6436 2.67158.0907.68744.0382 1.4276-.1462 2.16922.7497.18586 1.433.51 1.9959.94768.8792.68368 1.5067 1.68744 1.5067 2.87184 0 1.178-.6208 2.1775-1.4926 2.8608-.5451.4272-1.2044.7473-1.928.9377.1969.7219.2493 1.4529.1519 2.1386-.1559 1.0966-.7111 2.1341-1.7312 2.723-1.0258.5923-2.2088.5506-3.2405.1311-.6605-.2687-1.2828-.6984-1.8186-1.2547-.5501.5306-1.1648.9461-1.8055 1.2113-.99705.4126-2.14134.4863-3.13547-.0876-.99412-.574-1.50241-1.6018-1.64357-2.6715-.0907-.6875-.03823-1.4276.14618-2.1692-.74968-.1859-1.43301-.51-1.99588-.9477-.87921-.6837-1.50676-1.6874-1.50676-2.8718 0-1.178.6209-2.17757 1.49268-2.86086.54512-.42726 1.20442-.74737 1.92807-.93775-.19695-.7219-.24938-1.45293-.15192-2.13865.15586-1.09663.71103-2.13412 1.73121-2.72312zm2.487 1.72163c-.59668-.24267-1.11184-.20617-1.48699.01042-.37327.21551-.66121.6399-.75112 1.2725-.081126.570816.0120114 1.2646062.32959656 1.95865074l.11424344.23118926.75069 1.41253-1.59863.05616c-.87094.0306-1.61418.3154-2.11838.7105-.50288.3942-.72645.8558-.72645 1.2868 0 .4332.22597.8975.73447 1.293.46330909.3602727 1.12578347.627405 1.90193103.6919301l.23616897.0131699 1.49966.0432-.6169 1.3676c-.38387.851-.50097 1.6746-.41605 2.3181.08504.6445.3523 1.023.66075 1.2011s.7699.2203 1.37059-.0283c.53982-.22347 1.1240928-.661509 1.6329271-1.2993912l.1666529-.2200088.8759-1.2181.7872 1.2772c.4608.7475 1.0818 1.2558 1.6798 1.499.5967.2427 1.1118.2062 1.487-.0104.3732-.2155.6612-.6399.7511-1.2724.08109-.57087-.01197-1.264617-.3295539-1.9586232l-.1142461-.2311768-.7505-1.4124 1.5984-.0562c.8709-.0307 1.6141-.3154 2.1183-.7106.5029-.3942.7264-.8557.7264-1.2867 0-.4332-.226-.8976-.7344-1.293-.4633636-.3602727-1.1258182-.627405-1.9019391-.6920053l-.2361609-.0131947-1.4997-.04318.6169-1.36759c.3839-.85099.501-1.6746.4161-2.31816-.085-.64453-.3523-1.02306-.6608-1.20114-.3084-.17794026-.7698-.22028-1.3705.02833-.53982.223407-1.124109.6614478-1.6328736 1.29935286l-.1666264.22001714-.876 1.21804-.7872-1.27715c-.4608-.74759-1.0817-1.25586-1.67976-1.49907zm2.51296 2.93859c2.2092 0 4 1.79086 4 3.99996 0 2.2092-1.7908 4-4 4-2.2091 0-3.99996-1.7908-3.99996-4 0-2.2091 1.79086-3.99996 3.99996-3.99996zm0 2c-1.1045 0-2 .89546-2 1.99996 0 1.1046.8955 2 2 2 1.1046 0 2-.8954 2-2 0-1.1045-.8954-1.99996-2-1.99996z" fill="oklch(var(--p))"/></g></svg>

            <!-- <span class="relative ping rounded-full h-3 w-3 bg-primary" />
                <span class="absolute h-3 w-3 rounded-full bg-primary " /> -->
          </span>
        </div>
      </NuxtLink>
      <v-icon
        icon="mdi-heart"
        size="large"
        style="color: oklch(var(--n));"
        @click.stop="wishdrawer = !wishdrawer"
      />
      <!-- <NuxtLink to="/search">
        <v-icon
          icon="mdi-magnify"
          size="large"
          style="color: oklch(var(--n));"
        />
      </NuxtLink> -->
    </div>
    <div v-if="$device.isMobile" class="relative mt-5">
      <v-app-bar
        elevation="3"
        class="text-base-content bg-base-200"
      >
        <NuxtLink
          to="/"
        >
          <template v-if="useRuntimeConfig().public.SHOP_NAME=='NyxKnacks'">
            <p class="pacifico text-2xl ml-3">
              NyxKnacks
            </p>
          </template>
          <template v-if="useRuntimeConfig().public.SHOP_NAME=='LSDOPE'">
            <p class="text-2xl ml-3 font-bold">
              LSDope
            </p>
          </template>
        </NuxtLink>
        <div class="absolute right-0">
          <NuxtLink to="/account">
            <v-btn
              icon="mdi-account"
            />
          </NuxtLink>
          <NuxtLink to="/checkout">
            <v-btn
              icon="mdi-cart"
            />
            <!--Items In Cart Ping Icon-->
            <!-- v-if="items in cart are greater than 0" -->
            <div v-if="useUserDataStore().userData.cart.length>0" class="fixed top-3 right-[95px]">
              <span class="relative flex h-5 w-5 justify-center align-center">
                <!-- <v-icon icon="mdi-flower-poppy" color="primary" class="spin" /> -->
                 <svg class="spin" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="m0 0h24v24h-24z" fill-rule="nonzero"/><path d="m7.00004 3.33972c1.02576-.59222 2.20878-.5506 3.24046-.13102.6605.26862 1.2829.69834 1.8187 1.25465.55-.53051 1.1648-.94601 1.8054-1.21117.9971-.41264 2.1413-.48636 3.1354.0876.9942.57396 1.5025 1.6018 1.6436 2.67158.0907.68744.0382 1.4276-.1462 2.16922.7497.18586 1.433.51 1.9959.94768.8792.68368 1.5067 1.68744 1.5067 2.87184 0 1.178-.6208 2.1775-1.4926 2.8608-.5451.4272-1.2044.7473-1.928.9377.1969.7219.2493 1.4529.1519 2.1386-.1559 1.0966-.7111 2.1341-1.7312 2.723-1.0258.5923-2.2088.5506-3.2405.1311-.6605-.2687-1.2828-.6984-1.8186-1.2547-.5501.5306-1.1648.9461-1.8055 1.2113-.99705.4126-2.14134.4863-3.13547-.0876-.99412-.574-1.50241-1.6018-1.64357-2.6715-.0907-.6875-.03823-1.4276.14618-2.1692-.74968-.1859-1.43301-.51-1.99588-.9477-.87921-.6837-1.50676-1.6874-1.50676-2.8718 0-1.178.6209-2.17757 1.49268-2.86086.54512-.42726 1.20442-.74737 1.92807-.93775-.19695-.7219-.24938-1.45293-.15192-2.13865.15586-1.09663.71103-2.13412 1.73121-2.72312zm2.487 1.72163c-.59668-.24267-1.11184-.20617-1.48699.01042-.37327.21551-.66121.6399-.75112 1.2725-.081126.570816.0120114 1.2646062.32959656 1.95865074l.11424344.23118926.75069 1.41253-1.59863.05616c-.87094.0306-1.61418.3154-2.11838.7105-.50288.3942-.72645.8558-.72645 1.2868 0 .4332.22597.8975.73447 1.293.46330909.3602727 1.12578347.627405 1.90193103.6919301l.23616897.0131699 1.49966.0432-.6169 1.3676c-.38387.851-.50097 1.6746-.41605 2.3181.08504.6445.3523 1.023.66075 1.2011s.7699.2203 1.37059-.0283c.53982-.22347 1.1240928-.661509 1.6329271-1.2993912l.1666529-.2200088.8759-1.2181.7872 1.2772c.4608.7475 1.0818 1.2558 1.6798 1.499.5967.2427 1.1118.2062 1.487-.0104.3732-.2155.6612-.6399.7511-1.2724.08109-.57087-.01197-1.264617-.3295539-1.9586232l-.1142461-.2311768-.7505-1.4124 1.5984-.0562c.8709-.0307 1.6141-.3154 2.1183-.7106.5029-.3942.7264-.8557.7264-1.2867 0-.4332-.226-.8976-.7344-1.293-.4633636-.3602727-1.1258182-.627405-1.9019391-.6920053l-.2361609-.0131947-1.4997-.04318.6169-1.36759c.3839-.85099.501-1.6746.4161-2.31816-.085-.64453-.3523-1.02306-.6608-1.20114-.3084-.17794026-.7698-.22028-1.3705.02833-.53982.223407-1.124109.6614478-1.6328736 1.29935286l-.1666264.22001714-.876 1.21804-.7872-1.27715c-.4608-.74759-1.0817-1.25586-1.67976-1.49907zm2.51296 2.93859c2.2092 0 4 1.79086 4 3.99996 0 2.2092-1.7908 4-4 4-2.2091 0-3.99996-1.7908-3.99996-4 0-2.2091 1.79086-3.99996 3.99996-3.99996zm0 2c-1.1045 0-2 .89546-2 1.99996 0 1.1046.8955 2 2 2 1.1046 0 2-.8954 2-2 0-1.1045-.8954-1.99996-2-1.99996z" fill="oklch(var(--p))"/></g></svg>

                <!-- <span class="relative ping rounded-full h-3 w-3 bg-primary" />
                <span class="absolute h-3 w-3 rounded-full bg-primary " /> -->
              </span>
            </div>
          </NuxtLink>
          <v-btn
            icon="mdi-heart"
            @click.stop="wishdrawer = !wishdrawer" 
          />
          
          
          <v-btn
            icon="mdi-brightness-4"
            @click="themedrawer = !themedrawer"
          />
        </div>
      </v-app-bar>
    </div>
    <!-- <div v-if="asidebar==true"> -->
    
    <!-- </div> -->

    <v-main order="0" class="">
      <ShopHeader v-if="!((useRoute().path=='/' || useRoute().path.startsWith('/shop/products/')) || $device.isMobile)" />
      <slot />       
    </v-main>
    <ShopFooter v-if="((useRoute().path=='/' || useRoute().path.startsWith('/shop/products/')) && $device.isDesktopOrTablet)" class="ml-[250px]" />
    <ShopFooter v-else class="absolute bottom sticky bg-base-200" />
  </v-app>
</template>

<script setup>
import { useTheme } from 'vuetify'
import { useUserDataStore } from '#imports';

const tabs = ref(['All'])
tabs.value = [
  'All',
  'Candles',
  'Mugs',
  'Puzzles',
  'Journals',
]

const wishdrawer = ref(null)
const themedrawer = ref(null)
// const daisyTheme = ref(useUserDataStore().userData.theme)
const theme = useTheme()
function toggleTheme () {
  theme.global.name.value = theme.global.current.value.dark ? 'myPurpleTheme' : 'myDarkTheme'
}
const daisyClick = (themeName) => {
  console.log(themeName +" clicked")
  useUserDataStore().userData.theme = themeName
}
  // if(useRoute().path=="/"){
    //on desktop
      //yes load ASideBar
      //no don't load topbar
      //no don't load ShopHeader
  // } else {
    //on desktop
      //no don't load sidebar
      //yes load topbar
      //yes load header
  // }

  //FOR EXACTING CLARITY
  //If the sidebar is there, we dont want topbar and header.
  //If we are on mobile, or on any page but index, we want topbar and header (not sidebar)
  //If we are on desktop index, we want sidebar, not topbar and header

  //SIDEBAR = Desktop Index ONLY
  //TOPBAR = Every page EXCEPT Desktop Index
  //HEADER = Every page EXCEPT Desktop Index, ONLY MOBILE on Index

  // const { isMobile } = useDevice()
</script>

<style scoped>

* {
  font-family: 'Raleway', sans-serif;
}

/* NYX KNACKS */
.backimg {
  background: #ffffff url(https://static.basicinvite.com/media/bi/36259/dainty-flower-garden-wallpaper-2x.jpg?q=1701885786) center repeat;
}

.pacifico {
  font-family: 'Pacifico';
}

/* Not sure this needs to exist here */
.colors {
  height: 100px;
  width: 100%;
  padding: 15px;
  text-align: center;
}

.backdiv{
  height: screen;
  width: 100vw;
  position: fixed;
  top:0px;
  bottom: 0px;
  left:0px;
  right: 0px;
  z-index: 0;
  opacity: 70%;
  background: oklch(var(--nc));
  background: radial-gradient(oklch(var(--b1)) 0%, oklch(var(--b1)) 60%, oklch(var(--s)) 100%);
} 

.ping {
	 animation: ping 2s ease-out infinite;
}

 @keyframes ping {
	 0% {
		 scale: 1;
     opacity: .7;
	}
	 50% {
		 scale: 1.7;
     /* opacity: .3; */
	}
  100% {
		 scale: 1;
     opacity: 0;
	}
}

.spin {
  animation: linear spin 5s infinite;
}

@keyframes spin {
  100% {transform: rotate(360deg);}
}

</style>